import React from 'react';
import Modal from 'react-bootstrap-modal';

export default class InformationModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "",
            message: "",
            promiseResolve: null
        };
    }

    open(title, message) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                title: title,
                message: message,
                promiseResolve: resolve
            });
        });
        return promise;
    }

    close() {
		if (this.state.promiseResolve) {
			this.state.promiseResolve();
		}
        this.setState({
            isOpen: false,
            title: "",
            message: "",
            promiseResolve: null
        });
    }

    render() {
		let messageStyle = {
			whiteSpace: 'pre-line',
			wordBreak: 'break-word'
		};
        return (
            <Modal show={this.state.isOpen} onHide={() => this.close(false)} aria-labelledby="ModalHeader" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title id='ModalHeader'>{this.state.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p style={messageStyle}>{this.state.message}</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className='btn btn-default' onClick={() => this.close()}>OK</button>
                </Modal.Footer>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/infoModal.jsx